import customAxios from '../../customHook/customAxios';

const unwrap = (response) => {
    const body = response?.data;
    if (body?.status !== 1 && body?.status !== true && body?.allowed === false) throw new Error(body?.error || 'Training request failed.');
    return body?.result;
};

export const fetchTrainingWorkspace = () => customAxios.get('/v3/training', { meta: { skipLoader: true } }).then(unwrap);
export const saveTrainingCourse = (course) => customAxios.put('/v3/training/course', course, { meta: { skipLoader: true } }).then(unwrap);
export const archiveTrainingCourse = (courseId) => customAxios.delete(`/v3/training/course/${encodeURIComponent(courseId)}`, { meta: { skipLoader: true } }).then(unwrap);
export const saveTrainingAssignment = (assignment) => customAxios.post('/v3/training/assignment', assignment, { meta: { skipLoader: true } }).then(unwrap);
export const removeTrainingAssignment = (assignmentId) => customAxios.delete(`/v3/training/assignment/${encodeURIComponent(assignmentId)}`, { meta: { skipLoader: true } }).then(unwrap);
export const saveTrainingProgress = (courseId, progress) => customAxios.put(`/v3/training/progress/${encodeURIComponent(courseId)}`, progress, { meta: { skipLoader: true } }).then(unwrap);
export const generateTrainingQuestionnaire = (payload) => customAxios.post('/v3/training/questionnaire', payload, { meta: { skipLoader: true } })
    .then(unwrap)
    .catch((error) => {
        const message = error?.response?.data?.error || error?.message || 'Unable to generate the questionnaire.';
        throw new Error(message);
    });
export const generateSmsAssessmentQuestions = (payload) => customAxios.post('/v3/sms/assessment/questions', payload, { meta: { skipLoader: true } })
    .then(unwrap)
    .catch((error) => {
        const message = error?.response?.data?.error?.message || error?.message || 'Unable to generate SMS assessment questions.';
        throw new Error(message);
    });
export const fetchTrainingMedia = (url) => customAxios.get(url, { responseType: 'blob', meta: { skipLoader: true } }).then((response) => response.data);
export const createTrainingPlaybackUrl = (mediaPath) => customAxios.post(`${mediaPath.split('?')[0]}/playback`, {}, { meta: { skipLoader: true } }).then((response) => response.data.url);

export const uploadTrainingMedia = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return customAxios.post('/v3/training/media', formData, { meta: { skipLoader: true } }).then((response) => {
        const result = unwrap(response);
        return result;
    });
};
